<template>

  <v-main>
    <router-view v-if="ready" />


<!-- 
    <v-btn fab bottom letf fixed @click="$vuetify.theme.dark = !$vuetify.theme.dark">
      <v-icon>{{ $vuetify.theme.dark ? 'mdi-brightness-4' : 'mdi-brightness-7'}}</v-icon>
    </v-btn>

 -->
  </v-main>
</template>

<script>
  /**
   * Возможны три варианты работы
   * 1) Полный цикл
   * Регистрация + Привязка услуг, осуществляется при переходе на ссылку /webview/registration 
   * При успешной регистрации переход с параметрами registation-ok, иначе cancel
   * 2) Только привязка
   * При перехода по ссылке /webview/registration?wire=[token] перенаправлять на /webview/onlywire
   * При успехе wired-ok - иначе cancel
   * 3) Привязка телефона
   * При переходе на ссылку /webview/onlyphone
   * При успехе phone-ok
   */

  export default {

    beforeRouteEnter(to, from, next) {

      if (to.query.wire && to.name == "wv-registration") {

        next({
          name: "wv-wireservices",
          query: to.query
        })

      } else {
        next(vm => vm.parseRoute(to))
      }


    },

    data() {
      return {

        ready: false,
        initLocation: '',


        initRoute: null
      }
    },

    methods: {


      initWebView(route) {
        this.initRoute = {
          name: route.name,
          query: {...route.query}
        }

        if (this.initRoute.query.wire) {
          this.auth(route.query.wire)
        }else {
          this.ready = true
        }
      },

      parseRoute(route) {
        this.parseWebViewRoute(route)
        if (route.query.wire) {
          this.auth(route.query.wire)
        } else {
          this.ready = true
        }
      },


      auth(token) {
        this.$eventBus.$emit('loader:show')
        this.$store.dispatch('secure/AUTH', token)
          .then(res => {
            this.ready = true
          })
          .catch(error => {
            this.$eventBus.$emit('error', error)
          })
          .finally(() => {
            this.$eventBus.$emit('loader:hide')
          })
      },

      cancel() {
        this.$router.push({
          name: 'wv-away',
          params: {
            result: 'cancel'
          }
        })
      },

      wirePhone() {
        this.$router.push({
          name: 'wv-registration',
          params: {
            newUser: false
          }
        })
      },


      showDialog(message, acceptText, onAccept, rejectText, onReject) {


        this.$eventBus.$emit('modal:dialog', {

          dialogProps: {
            noClickAnimation: true,
            persistent: true,
          },
          props: {
            message: message,
            acceptText: acceptText || 'Ok',
            rejectText: rejectText
          },
          listeners: {
            accept: () => {
              onAccept()
            },
            reject: () => {
              onReject()
            }
          }
        })
      },

      catchCallback(error) {
        switch (error.code) {
          case 10: { //просто информирование
            this.showDialog(error.message)
            break;
          }
          case 11: { //сессия пользователя с момента его последнего действия устарела (отложил телефон - ушел по делам - вернулся)
            this.reset()
            break;
          }
          case 12: { //пользователь пытался привязать слишком много адресов за короткий промежуток времени
            this.showDialog(error.message, 'Ok', this.cancel)
            break;
          }
          case 13: { //пользователь попытался пол учить доступ к тем ресурсам/функциям для которых нужен привязанный телефон
            this.showDialog(error.message, 'Привязать', this.wirePhone, 'Отмена', this.cancel)
            break;
          }
          case 20:
          case 99: {
            this.throwError(error.message)
            break;
          }
          default: {
            this.throwError(error)
            break;
          }
        }
      },
      throwError(errorMessage) {
        this.$router.push({
          name: 'wv-error',
          params: {
            errorMessage
          }
        })
      },
      reset() {
        this.$router.push({
          name: this.options.initRouteName
        })
      },


    },

    created() {





      /*       this.parseWebViewRoute(this.$route) */

      this.$eventBus.$on('error', error => {
        this.catchCallback(error)
      })


    }
  }
</script>

<style>

</style>